import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import InsolvencyLawyerPage from './pages/InsolvencyLawyerPage';
import ExecutionLawyerPage from './pages/ExecutionLawyerPage';
import DebtSettlementLawyerPage from './pages/DebtSettlementLawyerPage';
import CompanyLiquidationPage from './pages/CompanyLiquidationPage';
import MonetaryClaimsLawyerPage from './pages/MonetaryClaimsLawyerPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import TopicPage from './pages/TopicPage';
import AdminPage from './pages/admin/AdminPage';
import FAQPage from './pages/FAQPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoginForm from './components/LoginForm';
import PrivacyPage from './pages/PrivacyPage';
import AccessibilityPage from './pages/AccessibilityPage';
import TermsPage from './pages/TermsPage';
import AccessibilityMenu from './components/AccessibilityMenu';
import FloatingContactButton from './components/FloatingContactButton';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ThankYouPage from './pages/ThankYouPage';
import ArticlePage from './pages/ArticlePage';
import CardPage from './pages/CardPage';
import PressPopup from './components/PressPopup';
import CookieBanner from './components/CookieBanner';
import './components/accessibility.css'
import './App.css';

// קומפוננט עוטף שבודק את המיקום הנוכחי
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isLoginRoute = location.pathname === '/login';
  const isHomePage = location.pathname === '/'; // בדיקה אם זה דף הבית
const isCardPage = location.pathname === '/card';
  return (
    <>
      {/* תפריט נגישות */}
      {!isAdminRoute && !isLoginRoute && <AccessibilityMenu />}
      
      {/* כפתור יצירת קשר צף */}
      {!isAdminRoute && !isLoginRoute && <FloatingContactButton />}

      {/* פופאפ הכתבה - יקפוץ רק בדף הבית */}

      {/* כפתור WhatsApp צף */}
      {!isAdminRoute && !isLoginRoute && <FloatingWhatsApp />}
      
      {/* באנר קוקיז */}
      {!isAdminRoute && !isLoginRoute && <CookieBanner />}
       
   
      <div className="min-h-screen bg-white  flex flex-col">
        {/* הצג את הנאבבר רק אם לא בדפי אדמין או התחברות */}
        {!isAdminRoute && !isLoginRoute && <Navbar />}

        {/* תוכן ראשי עם flex-grow כדי לדחוף את הפוטר למטה */}
        <main className={`flex-grow ${!isAdminRoute && !isLoginRoute ? "pt-20" : ""}`}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/insolvency-lawyer" element={<InsolvencyLawyerPage />} />
            <Route path="/execution-lawyer" element={<ExecutionLawyerPage />} />
            <Route path="/debt-settlement-lawyer" element={<DebtSettlementLawyerPage />} />
            <Route path="/company-liquidation" element={<CompanyLiquidationPage />} />
            <Route path="/monetary-claims-lawyer" element={<MonetaryClaimsLawyerPage />} />
            <Route path="/topic/:topicId" element={<TopicPage />} />
            <Route path="/topic/:topicId/:articleId" element={<ArticlePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/login" element={<LoginForm />} />
            {/* דפים חדשים */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/card" element={<CardPage />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>

        {/* הצג את הפוטר רק אם לא בדפי אדמין או התחברות */}
        {!isAdminRoute && !isLoginRoute && <Footer />}

      </div>
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;